import type { FaireProductEntity } from "../../entity_types/product";

export const p_mh5ctvspga: FaireProductEntity = {
  token: "p_mh5ctvspga",
  type: "product",
  name: "Wholesale Newborn Crochet Girl Pink Hat Cardigan Sweater Pants Booties 4 Piece Outfit Set",
  brandToken: "b_tvcr3rrcqs",
  brandName: "b-one inc",
  imageUrl:
    "https://cdn.faire.com/fastly/06b304b3dc4bf4d9a9f91ea9f762f80a37a1b4d0b11bcd88e4776cc17045fb11.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/16ccd4e0a33b38583d77982e989e784ca96e9acf03dd51c2b6d321b672d9f00d.jpeg",
    "https://cdn.faire.com/fastly/6b7081065a81e363a9d3f643f12e8e49ecf2294222123c6cb727662f1394ec5e.jpeg",
    "https://cdn.faire.com/fastly/225604d0208d693a7954a9f9a26d3b7a867e64a010e4878d27c57bcb430e76ed.jpeg",
    "https://cdn.faire.com/fastly/176fbcc1cfa2b747100668bb2a938f1bc97f14e2237d2a1f7e9f9e2d6ae773d0.jpeg",
    "https://cdn.faire.com/fastly/8d57c33c09f6871a53966b7d3710a18c805212fdf05234cf9d7ea9a7e19e87d9.jpeg",
  ],
  priceDollars: 10,
  description:
    "\n * Includes: Hat, Cardigan Sweater, Pants, & Mittens \n * 100% Acrylic \n * Color: Pink, Green, White, Yellow \n * Newborn 0-3 Months \n * Made In Mexico \n * US Shipper ",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:27:08.021Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
